module.exports = __webpack_public_path__ + "static/___006___Professional-property-management-services.02940019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___006___Professional-property-management-services.jpg
// module id = 1282
// module chunks = 64098118039141